import  { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SessionTimer = ({ expirationDuration }) => {
  const navigate = useNavigate();
  let logoutTimer;

  const startTimer = () => {
    logoutTimer = setTimeout(() => {
      navigate("/login");
    }, expirationDuration);
  };

  const resetTimer = () => {
    clearTimeout(logoutTimer);
    startTimer();
  };

  useEffect(() => {
    startTimer();

    // Reset the timer on user activity (e.g., mouse move, key press)
    const handleUserActivity = () => {
      resetTimer();
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
    };
  }, []);

  return null;
};

export default SessionTimer;
